import home from '@/pages/home'

export const routes = [{
  path: '/',
  component: home,
  name: 'home'
}]



// WEBPACK FOOTER //
// ./src/router/home.js